import React from 'react';
import PropTypes from 'prop-types';
import { css, Global } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';

const allhomesGlobalStyles = css`
  body {
    background-color: ${tokens.colors.neutral.surface.default};
  }

  :focus-visible {
    outline-color: ${tokens.colors.neutral.trim.pressed};
  }
`;

const EmotionWrapper = ({ children }) => (
  <>
    <Global styles={allhomesGlobalStyles} />
    {children}
  </>
);

EmotionWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default EmotionWrapper;
